import React, { useState } from 'react';
import { TextField, Button, Grid, Typography } from '@material-ui/core';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';
import { translateError } from '../../../utils/messages';

const EditLoginInfo = () => {
  const [email, setEmail] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const history = useHistory(); 

  const validatePassword = (password) => {
    const minLength = password.length >= 8;
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    
    if (!minLength) return 'パスワードは最低8文字必要です。';
    if (!hasLowercase) return 'パスワードには小文字（a〜z）を含めてください。';
    if (!hasNumber) return 'パスワードには数字（0〜9）を含めてください。';
    
    return '';
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('')
    
    if (newPassword && !oldPassword) {
      setMessage('パスワードを変更するには現在のパスワードを入力してください。');
      setLoading(false);
      return;
    }

    if (newPassword) {
      const passwordError = validatePassword(newPassword);
      if (passwordError) {
        setMessage(passwordError);
        setLoading(false);
        return;
      }
    }

  try {
    // 現在のユーザー情報を取得
    const user = await Auth.currentAuthenticatedUser();

    // メールアドレスを更新
    if (email) {
      await Auth.updateUserAttributes(user, { email });
    }

    // パスワードを更新
    if (oldPassword && newPassword) {
      await Auth.changePassword(user, oldPassword, newPassword);
    }

    setMessage('更新が完了しました。');
    } catch (error) {
      console.error('更新エラー:', error);
      setMessage(`エラー: ${translateError(error.message)}`);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    history.goBack();  // 戻る操作
  };

  return (
    <Grid container justify="center" style={{ padding: '20px' }}>
      <Grid item xs={12} sm={6}>
        <Typography variant="h5" style={{ marginBottom: '20px' }}>
          ログイン情報を編集
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="メールアドレス"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
           <TextField
            label="現在のパスワード"
            variant="outlined"
            type="password"
            fullWidth
            margin="normal"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />
          <TextField
            label="新しいパスワード"
            variant="outlined"
            type="password"
            fullWidth
            margin="normal"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />

        {message && <Typography color="secondary">{message}</Typography>}

        <Grid container justifyContent="center">
          <Button 
            variant="contained" 
            color="primary" 
            type="submit" 
            style={{ marginTop: '10px', width: '300px' }}
            disabled={loading}
          >
            {loading ? '更新中...' : '保存'}
          </Button>
          </Grid>
        </form>
        
        <Grid container justifyContent="center">
        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          style={{ marginTop: '20px' , width: '300px'}}
          onClick={handleBack}
        >
          戻る
        </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EditLoginInfo;

